(function ($, ns) {
    "use strict";

    var ThemeMap = function (context, opts, init) {
      this.$context = (context instanceof jQuery) ? context : $(context);

      this.map = null;
      this.panel = null;
      this.panelCache = {};

      if (opts) {
        this.opts = $.extend(this.getDefaultOpts(), opts);
      }

      if (init !== false && !$('body').hasClass('wp-admin')) {
        this.init();
      }
    };

    var parentPrototype = window.pew.getRegistryEntry('wdf-plugin-map').classDef.prototype;
    ThemeMap.prototype = jQuery.extend({}, parentPrototype);


    ThemeMap.prototype.enableMarkerHover = function (marker) {
      var self = this;

      if ($('html').hasClass('touch-enabled')) {
        return false; //No hover on touch devices
      }

      marker.hoverPopin = self.getHoverPopin(marker);
      if (marker.hoverPopin) {
        this.map.enableMarkerHover(marker, self.markerHoverIn.bind(this), self.markerHoverOut.bind(this));
      }
    },

      ThemeMap.prototype.getHoverPopinContent = function (marker) {

        //Disabling hovers on beforeAfter
        if (marker.className === 'beforeAfter') {
          return false;
        }

        var linkStart = '',
          linkEnd = '';


        var popinContent = (typeof marker.data.markup === 'string') ? marker.data.markup : {
          title: linkStart + marker.data.title.replace('\\', '') + linkEnd,
          img: marker.data.visual ? linkStart + '<img src="' + marker.data.visual + '">' + linkEnd : '',
          desc: (marker.data && marker.data.content) ? marker.data.content.replace('\\', '') : ''
        };

        return this.map.createPopinContent(marker, popinContent);
      }

    //==[ KML ] ===================================================================================
    ThemeMap.prototype.addKml = function (kmlId, kmlUrl, onClickCallback) {
      var self = this,
        kmlLayer = this.map.addKmlToMap(kmlId, kmlUrl, onClickCallback);
      if (kmlId === 'kml-col-14') {
        if ($('html').hasClass('touch-enabled')) {
          kmlLayer.on('click', function (kmlEvent) {
            console.log(kmlEvent);
            self.openGardenPopin(kmlEvent,false);
          });
        } else {
          kmlLayer.on('mouseover', function (kmlEvent) {
            self.openGardenPopin(kmlEvent,true);
          });
          kmlLayer.on('mouseout', function (kmlEvent) {
            var layer = kmlEvent.layer;
            layer.closePopup();
          });
        }
      }

      return kmlLayer;
    };

    ThemeMap.prototype.openGardenPopin = function (kmlEvent,autoClose) {
      var layer = kmlEvent.layer,
        popupOpts = {
          minWidth: 150,
          offset: new L.Point(3, -15),
          className: 'popin-jardin',
          autoClose: autoClose //set to false to keep the popin on screen
        };
      layer.bindPopup('<span class="nom-jardin">' + layer.name + '</span>', popupOpts).openPopup();
    }

    ThemeMap.prototype.getSizes = function (col) {
      return [12, 12];
    },

      window.pew.addRegistryEntry({key: 'wdf-plugin-map', domSelector: '.map-form, .module-map', classDef: ThemeMap});
  }
)(jQuery, window.wonderwp);
